import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Grundlagen from './pages/Grundlagen';
import QualityCriteria from './pages/QualityCriteria';
import QualitaetPruefung from './pages/QualitaetPruefung';
import SpecificFeatures from './pages/SpecificFeatures';
import FeatureDetail from './pages/FeatureDetail';
import Reaction from './pages/Reaction';
import Applications from './pages/Applications';
import Zementsubstitution from './pages/Zementsubstitution';
import Silikastaub from './pages/Silikastaub';
import NewchemKompetenz from './pages/NewchemKompetenz';
import Wissen from './pages/Wissen';
import UeberMetakaolinInfo from './pages/UeberMetakaolinInfo';
import Fachredaktion from './pages/Fachredaktion';
import Downloads from './pages/Downloads';
import CaseStudies from './pages/CaseStudies';
import ExternalLinks from './pages/ExternalLinks';
import Disclaimer from './pages/Disclaimer';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import Contact from './pages/Contact';

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <LanguageProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />

                {/* Scientific IA */}
                <Route path="grundlagen" element={<Grundlagen />} />
                <Route path="reaktion" element={<Reaction />} />
                <Route path="qualitaet-pruefung" element={<QualitaetPruefung />} />
                <Route path="eigenschaften" element={<SpecificFeatures />} />
                <Route path="eigenschaften/:slug" element={<FeatureDetail />} />
                <Route path="zementsubstitution" element={<Zementsubstitution />} />
                <Route path="anwendungen" element={<Applications />} />
                <Route path="wissen" element={<Wissen />} />
                <Route path="wissen/metakaolin-silikastaub" element={<Silikastaub />} />
                <Route path="newchem-kompetenz" element={<NewchemKompetenz />} />
                <Route path="ueber-metakaolin-info" element={<UeberMetakaolinInfo />} />
                <Route path="fachredaktion" element={<Fachredaktion />} />

                {/* Secondary / knowledge resources */}
                <Route path="downloads" element={<Downloads />} />
                <Route path="case-studies" element={<CaseStudies />} />
                <Route path="external-links" element={<ExternalLinks />} />
                <Route path="disclaimer" element={<Disclaimer />} />
                <Route path="impressum" element={<Impressum />} />
                <Route path="datenschutz" element={<Datenschutz />} />
                <Route path="contact" element={<Contact />} />

                {/* Backwards-compatible legacy paths (kept working) */}
                <Route path="reaction" element={<Reaction />} />
                <Route path="applications" element={<Applications />} />
                <Route path="quality-criteria" element={<QualityCriteria />} />
                <Route path="specific-features" element={<SpecificFeatures />} />
                <Route path="specific-features/:slug" element={<FeatureDetail />} />

                <Route path="*" element={<Home />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </LanguageProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
